import { storeToRefs } from "pinia";
import { checkFbsPermission } from "@/shared/helper";
import type { RouteLocationNormalizedGeneric } from "vue-router";
import { AppIdentifier, AppRouteNames } from "@/shared/@types";
import type { FbsCustomerType } from "@/app/fbs-hub-app/shared/@types";
import { useAuthenticatedUsersOnly } from "@/shared/router";
import { useGasContainerStore } from "@/app/fbs-hub-app/shared/stores";

export const redirectToAuthenticatedMeterReportIfPermitted = async (
  to: RouteLocationNormalizedGeneric,
) =>
  canAccessAuthenticatedMeterReport((await getFbsCustomerType(to)).value)
    ? { name: AppRouteNames.FbsHubMeterReport }
    : true;

export const redirectToUnauthenticatedMeterReportIfNotPermitted = async (
  to: RouteLocationNormalizedGeneric,
) =>
  !canAccessAuthenticatedMeterReport((await getFbsCustomerType(to)).value)
    ? { name: AppRouteNames.MeterReport }
    : true;

const canAccessAuthenticatedMeterReport = (
  fbsCustomerType: FbsCustomerType | undefined,
) => checkFbsPermission(AppRouteNames.FbsHubMeterReport, fbsCustomerType);

const getFbsCustomerType = async (to: RouteLocationNormalizedGeneric) => {
  const { hasUserData, initializeUserData } = useAuthenticatedUsersOnly(to);
  if (!hasUserData.value) await initializeUserData(AppIdentifier.FbsHub);

  const gasContainerStore = useGasContainerStore();
  await gasContainerStore.fetchGasContainers();

  const { fbsCustomerType } = storeToRefs(gasContainerStore);
  return fbsCustomerType;
};
